import { Component, computed, inject, input, output } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { UpcomingEvent } from '../../../../core/models';
import { LanguageService } from '../../../../core/services/language.service';
import {
  eventCompactDateLabel,
  eventLocationSummary,
  eventTypeLabel,
  eventTypeLabelKey,
} from '../../../utils/upcoming-event.mapper';

/**
 * Carte plein cadre avec résumé révélé au survol (clavier compris, via :focus-within) — inspirée
 * du site public du Cameroon International Tech Summit. Le clic renvoie le slug au parent, qui
 * décide de la navigation (mêmes conventions que OpportunityCard/OrganizationCard).
 */
@Component({
  selector: 'app-event-card',
  imports: [TranslatePipe],
  templateUrl: './event-card.html',
  host: { class: 'block h-full' },
})
export class EventCard {
  private readonly language = inject(LanguageService);
  private readonly translate = inject(TranslateService);

  readonly event = input.required<UpcomingEvent>();

  readonly open = output<string>();

  readonly typeLabelKey = computed(() => eventTypeLabelKey(this.event().eventType));
  /** Repli si le type d'événement n'est pas dans la liste connue (voir `eventTypeLabelKey`). */
  readonly typeLabelFallback = computed(() => eventTypeLabel(this.event().eventType));
  readonly dateLabel = computed(() =>
    eventCompactDateLabel(this.event().startAt, this.event().endAt, this.language.localeCode()),
  );
  /** `instant()` est sûr ici : `dateLabel`/le badge de type au-dessus sont déjà traduits via le pipe une fois le catalogue chargé. */
  readonly locationLabel = computed(() => eventLocationSummary(this.event(), this.translate.instant('events.online')));
  readonly coverUrl = computed(() => this.event().coverContentUrl || this.event().coverUrl);
}
